import _ from "lodash";
import {Debugger} from "debug";
const debug: Debugger = require('debug')('mockDato');


/** Metoder for å mocke Date slik at new Date() returnerer dato med et konstant offset.
 * basert på https://github.com/boblauer/MockDate */
export const datoformat = 'YYYY-MM-DD HH:mm Z';
export const javaNåDato = new Date("2007-12-03T11:15:00+01:00");

export function setMockDateTilJavaNå() {
    debug("setter nå-tidspunkt i javascript til " + javaNåDato);
    setMockDate(javaNåDato);
}

export function setMockDate(dato: Date) {
    Date = MockDate;
    offset = dato.getTime() - new _Date().getTime();
    //console.log("offset", offset);
}

export function resetMockDate() {
    Date = _Date;
}

/** Returnerer ikke-mocket nå-tidspunkt */
export function nyIkkeMocketDate(): Date {
    return new _Date();
}

//mock implementasjon

var _Date = Date;
var offset: number;

var MockDate: DateConstructor = <any>function (y, m, d, h, M, s, ms): Date {
    var date;

    switch (arguments.length) {
        case 0:
            if (offset !== null) {
                date = new _Date();
                date.setTime(date.getTime() + offset);
            } else {
                date = new _Date();
            }
            break;

        case 1:
            date = new _Date(y);
            break;

        default:
            d = _.isUndefined(d) ? 1 : d;
            h = _.isUndefined(h) ? 0 : h;
            M = _.isUndefined(M) ? 0 : M;
            s = _.isUndefined(s) ? 0 : s;
            ms = _.isUndefined(ms) ? 0 : ms;
            date = new _Date(y, m, d, h, M, s, ms);
            break;
    }

    return date;
};

MockDate.UTC = _Date.UTC;

MockDate.now = function () {
    return new MockDate().valueOf();
};

MockDate.parse = function (dateString) {
    return _Date.parse(dateString);
};

MockDate.toString = function () {
    return _Date.toString();
};

// @ts-ignore
MockDate.prototype = _Date.prototype;
